// eslint-disable-next-line no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux'
import { Store } from 'redux'

import { AppDispatch, RootState } from '.'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppStore: () => Store<RootState> = useStore
